import React, { FC } from 'react';
import s from './ListVideos.module.css'
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store/hooks/hooks';
import { Link } from 'react-router-dom';

interface ListVideosProps {
    technologie_id: string
    video_id: string
}

const ListVideos: FC<ListVideosProps> = ({ technologie_id, video_id }) => {
    const { t, i18n } = useTranslation()
    const { list_videos } = useAppSelector(state => state.list_courses)
    const lang = i18n.language

    return (
        <div className={s.list_wrapper}>
            <h3 className={s.list_title}>
                {t("video.list_title")} {lang === 'ru' ? list_videos?.technology_name_ru : list_videos?.technology_name_en}
            </h3>
            <div className={s.wrapper_links}>
                {
                    list_videos?.videos &&
                    list_videos.videos.map(el => (
                        <Link className={Number(video_id) === el.id ? `${s.active_video} ${s.video_link}` : s.video_link}
                            to={`/watch/video/${el.id}/${technologie_id}`}
                            key={el.id}>
                            <h4>{lang === 'ru' ? el.name_ru : el.name_en}</h4>
                        </Link>
                    ))
                }
            </div>
        </div>
    );
};

export default ListVideos;